import ModelPrompt, { ModelPromptComponent } from 'webmodals/model-prompt'
import $session from 'servicestack/session'

import userDeleteConfirmatioHtm from 'emun.auth/user-delete-confirmation.htm'
import changePasswordFieldset from 'emun.auth/change-password/change-password-fieldset.htm'
import registerConsumerFieldset from 'emun.auth/register-consumer-fieldset.htm'
import 'emun.auth/logout.htm'
import 'emun.auth/register-delete-confirmation.htm'
import 'emun.auth/user-delete-confirmation.htm'
import 'emun.auth/profile.session.htm'

export class AuthPrompt extends ModelPrompt {
    constructor() {
        super();
        this.seed = {
            status: 'Active',
            retailerId: $session.retailerId
        };
    }
    getTitle(model, action) {
        if (action === 'Delete') {
            return 'Delete account...';
        } else if (action === 'Change Password') {
            return 'Change Password...';
        } else {
            return 'Sign up for an account...';
        }
    }
    getQueryUrl(model, action) { return action === 'Update' && `QueryUsers.json?Id=${model && model.id}`; }
    getCommandUrl(model, action) {
        if (action === 'Delete') {
            return 'DeleteUser';
        } else if (action === 'Register') {
            return 'auth/Register/' + model.role;
        } else if (action === 'Change Password') {
            return 'ChangePassword';
        } else if (action === 'Reset Password') {
            return 'ResetPassword';
        } else {
            return 'auth/' + action;
        }
    }
    getModalBodyTemplateUrl(model, action) {
        if (action === 'Delete') {
            return userDeleteConfirmatioHtm;
        } else if (action === 'Change Password') {
            return changePasswordFieldset;
        } else if (action === 'Register') {
            return registerConsumerFieldset;
        } else {
            return `${action.toLowerCase()}-fieldset.htm`;
        }
    }
    mapModel(model, action) { return model; }

    //commands
    register(model) { return this._open(model, 'Register'); }
    add(model) { return this.register(model); }
    login(model) { return this._open(model, 'Login'); }
    logout(model) { this._open(model, 'Log out'); }
    changePassword(model) { return this._open(model, 'Change Password'); }
    resetPassword(model) { return this._open(model, 'Reset Password'); }
}

export default function register(app) {
    app.service('authPrompt', AuthPrompt)
        .component('authPrompt', new ModelPromptComponent('authPrompt'))
        .run((authPrompt, $rootScope) => $rootScope.$auth = authPrompt);
}